var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"my-4"},[_vm._v("Relatório")]),(_vm.itens)?_c('div',[_vm._m(0)]):_c('LoadingPage')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table",attrs:{"id":"datatable"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Aluno")]),_c('th',[_vm._v("Turma")]),_c('th',[_vm._v("Poló")]),_c('th',[_vm._v("Responsável")]),_c('th',[_vm._v("Grade")])])])])
}]

export { render, staticRenderFns }